import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { HallPass } from '../models/HallPass';
import { Invitation } from '../models/Invitation';
import { filter, takeUntil } from 'rxjs/operators';
import { HttpService } from '../services/http-service';
import { PassLike } from '../models';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-travel-view',
	templateUrl: './travel-view.component.html',
	styleUrls: ['./travel-view.component.scss'],
})
export class TravelViewComponent implements OnInit, OnDestroy {
	@Input() pass: PassLike;
	@Input() shrink = false;
	@Input() forStaff = false;
	@Input() height = '217px';
	@Input() textColor = '#ffffff';
	@Input() iconColor = '#ffffff';

	@Output() locationSelected = new EventEmitter<any>();

	showRoomNumber: boolean;
	destroy$ = new Subject<void>();

	constructor(private http: HttpService) {}

	get originRoomName() {
		if (this.showRoomNumber) {
			if (this.pass instanceof Invitation) {
				return this.pass.default_origin ? this.pass.default_origin.title + `${this.pass.default_origin.room}` : 'Origin';
			} else {
				return this.pass.origin.title + ` (${this.pass.origin.room})`;
			}
		} else {
			if (this.pass instanceof Invitation) {
				return this.pass.default_origin ? this.pass.default_origin.title : 'Origin';
			} else {
				return this.pass.origin.title;
			}
		}
	}

	get destinationRoomName() {
		return this.showRoomNumber ? this.pass.destination.title + ` (${this.pass.destination.room})` : this.pass.destination.title;
	}

	ngOnInit() {
		this.http.currentSchool$.pipe(takeUntil(this.destroy$), filter(Boolean)).subscribe((res) => {
			this.showRoomNumber = res.display_card_room;
		});
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
